<template>
    <div>
        <v-app-bar app color="header">
            <!-- Spacer to push elements to opposite ends -->
            <v-spacer></v-spacer>

            <!-- Logo Image -->
            <v-img v-if="app.room && app.room.settings && !['', null, 'test'].includes(app.room.settings.header_logo)" :src="app.room.settings.header_logo" max-height="40" contain position="center" />
            <v-img v-else-if="app.site && app.site.domain_settings && app.site.domain_settings.settings.header_logo && !['', null, 'test'].includes(app.site.domain_settings.settings.header_logo)" :src="app.site.domain_settings.settings.header_logo" max-height="40" contain position="center" />
            <div v-else-if="app.room" class="text-h5 font-weight-bold primary--text" style="text-align:center;width:100%;">{{app.room.post_title}}</div>
            <div v-else class="text-h5 font-weight-bold primary--text" style="text-align:center;width:100%;">VIPHuddles.com</div>

            <!-- Another Spacer for symmetry -->
            <v-spacer></v-spacer>

            <!-- Additional toolbar items or components here, if needed -->
        </v-app-bar>
    </div>
</template>

<script>
import { useAppStore } from "../stores/app"

export default {
	name: 'MeetingRecordingSystemBar',
    created() {
        this.app = useAppStore()
        this.app.getSiteSettings(this.$vuetify)
	},
    data: () => {
        return {
            app: null,
        }
    },
    mounted: function() {},
    methods: {}
}
</script>

<style scoped>
.v-list-item {
	cursor: pointer;
}
.v-toolbar__content {
    justify-content: center !important;
}
</style>
